// extracted by mini-css-extract-plugin
export default {"panel":"Carousel_panel__z-oUU","image":"Carousel_image__PmbLj"};